const messages = {
    pages: {
        main: {
            sections: {
                title: 'Stanowiska raportowania',
                actions: {
                    add: 'Dodaj stanowisko raportowania',
                    delete: 'Usuń'
                },
                filters: {
                    searchPlaceholder: 'Szukaj...',
                    typePlaceholder: 'Typy...'
                },
                table: {
                    columns: {
                        name: 'Nazwa',
                        number: 'Numer',
                        machine: 'Maszyna',
                        type: 'Typ stanowiska',
                        allowsSendingOrders: 'Czy można nadawać?'
                    }
                }
            },
            dialogs: {
                delete: {
                    title: 'Usuwanie stanowiska raportowania',
                    content: 'Czy na pewno chcesz usunąć stanowisko raportowania?',
                    confirm: 'Usuń'
                }
            },
            dialog: {
                titles: {
                    create: 'Tworzenie stanowiska raportowania',
                    edit: 'Edycja stanowiska raportowania {name}'
                },
                fields: {
                    name: 'Nazwa',
                    machine: 'Maszyna',
                    printers: 'Dostępne drukarki',
                    defaultPrinter: 'Drukarka domyślna',
                    number: 'Numer',
                    type: 'Typ stanowiska',
                    allowsSendingOrders: 'Czy stanowisko zezwala na nadawanie zamówień?'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę.',
                    machineRequired: 'Proszę wybrać maszynę.',
                    typeRequired: 'Proszę wybrać typ stanowiska.',
                    numberRequired: 'Proszę podać numer.',
                    defaultPrinterRequired: 'Proszę wybrać domyślną drukarkę.'
                }
            },
            notifications: {
                saved: 'Stanowisko raportowania zostało zapisane.',
                deleted: 'Stanowisko raportowania zostało usunięte.'
            },
            errors: {
                fetchList: 'Pobranie listy stanowisk nie powiodło się.',
                fetchOne: 'Pobranie stanowiska nie powiodło się.',
                save: 'Zapisanie stanowiska nie powiodło się.',
                delete: 'Usunięcie stanowiska nie powiodło się.',
                fetchPrinters: 'Pobranie drukarek nie powiodło się.',
                fetchTypes: 'Pobranie typów stanowisk nie powiodło się.',
                fetchAllowedItemTypes: 'Pobranie typów obiektów do raportowania nie powiodło się.',
                fetchMachines: 'Pobranie maszyn nie powiodło się.'
            }
        }
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
